import React from 'react';
import Header from '../components/resuableComponents/Header';
import Footer from '../components/resuableComponents/Footer';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Box, Container, Grid, useMediaQuery, useTheme } from '@mui/material';
import FlightSummaryForm from '../form/FlightSummaryForm';
import { useLocation } from 'react-router-dom';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import CoupanModal from '../components/resuableComponents/CoupanModal';
import { useDispatch } from 'react-redux';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { setModal } from '../reducers/UiReducer';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import TBODetail from '../components/resuableComponents/TBODetail';
import ETRDetail from '../components/resuableComponents/ETRDetail';
import TJKDetail from '../components/resuableComponents/TJKDetail';

const steps = ['Review', 'Travel Detail', 'Payment'];

const FlightDetailPage = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	console.log('location', location);
	return (
		<div>
			<Navbar />
			<Box style={{ padding: 20 }}>
				<Stepper activeStep={1} alternativeLabel>
					{steps.map((label) => (
						<Step key={label}>
							<StepLabel
								sx={{
									'.MuiStepLabel-label': {},
								}}>
								{label}
							</StepLabel>
						</Step>
					))}
				</Stepper>
			</Box>
			<Container style={{ marginTop: 10, marginBottom: 50 }}>
				<Grid container spacing={4}>
					<Grid item xs={12} lg={8}>
						{location?.state?.onward?.Supplier === 'TBO' &&
							location?.state?.onward?.Segments[0]?.map((i) => {
								return <TBODetail i={i} />;
							})}
						{location?.state?.onward?.Supplier === 'TBO' &&
							location?.state?.onward?.Segments.length > 1 &&
							location?.state?.onward?.Segments[1]?.map((i) => {
								return <TBODetail i={i} />;
							})}
						{location?.state?.onward?.Supplier === 'ETR' &&
							location?.state?.onward?.Segments?.map((i) => {
								return <ETRDetail i={i} />;
							})}
						{location?.state?.return?.Supplier === 'ETR' &&
							location?.state?.return?.Segments?.map((i) => {
								return <ETRDetail i={i} />;
							})}
						{location?.state?.onward?.Supplier === 'TJK' &&
							location?.state?.onward?.sI?.map((i) => {
								return <TJKDetail i={i} />;
							})}
						{location?.state?.return?.Supplier === 'TJK' &&
							location?.state?.return?.sI?.map((i) => {
								return <TJKDetail i={i} />;
							})}
						{location?.state?.onward?.Supplier === 'AIQ' && (
							<Box
								style={{
									boxShadow: '0 0 10px rgba(0,0,0,.3)',
									backgroundColor: '#FFF',
									marginTop: 20,
								}}>
								<Box
									style={{
										backgroundColor: '#E1E1E1',
										color: 'rgba(0,0,0,.64)',
										padding: 10,
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}>
									<Box
										style={{
											display: 'flex',
											alignItems: 'center',
										}}>
										<img
											src={`https://nitish.musafirbazar.com/static/media/${
												location?.state?.onward?.flight_number?.split(' ')[0]
											}.gif`}
											style={{ height: 35 }}
										/>
										<span style={{ fontSize: 14, marginLeft: 10 }}>
											{`${location?.state?.onward?.airline} ${
												location?.state?.onward?.flight_number?.split(' ')[0]
											}-${
												location?.state?.onward?.flight_number?.split(' ')[1]
											}`}
										</span>
									</Box>
								</Box>

								<Box
									style={{
										padding: 20,
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}>
									<Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<h1>{location?.state?.onward?.origin}</h1>
											<span style={{ fontSize: '24px', marginLeft: '12px' }}>
												{location?.state?.onward?.departure_time}
											</span>
										</Box>
										<Box>
											<span style={{ fontSize: 12, color: 'grey' }}>
												{location?.state?.onward?.departure_date}
											</span>
											<br />
											<span style={{ fontSize: 12, color: 'grey' }}></span>
											<br />
											<span style={{ fontSize: 12, color: 'grey' }}></span>
										</Box>
									</Box>
									<Box>
										<Box style={{ alignItems: 'center', textAlign: 'center' }}>
											<AccessTimeIcon />
											<h2>2hr 30mn</h2>
										</Box>
									</Box>
									<Box>
										<Box
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'end',
											}}>
											<h1>{location?.state?.onward?.destination}</h1>
											<span style={{ fontSize: '24px', marginLeft: '12px' }}>
												{location?.state?.onward?.arival_time}
											</span>
										</Box>
										<Box style={{ textAlign: 'end' }}>
											<span style={{ fontSize: 12, color: 'grey' }}>
												{location?.state?.onward?.arival_date}
											</span>
											<br />
											<span style={{ fontSize: 12, color: 'grey' }}></span>
											<br />
											<span style={{ fontSize: 12, color: 'grey' }}></span>
										</Box>
									</Box>
								</Box>
							</Box>
						)}
						{location?.state?.return?.Supplier === 'TBO' &&
							location?.state?.return?.Segments[0]?.map((i) => {
								return <TBODetail i={i} />;
							})}
						{matches ? (
							<>
								<Box
									style={{
										boxShadow: '0 0 10px rgba(0,0,0,.3)',
										backgroundColor: '#FFF',
										marginTop: 20,
										// padding: 10,
									}}>
									<Box
										style={{
											backgroundColor: '#E1E1E1',
											color: 'rgba(0,0,0,.64)',
											padding: 10,
										}}>
										<span>Offers</span>
									</Box>
									<Box
										onClick={() => dispatch(setModal(true))}
										style={{
											padding: 12,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
											cursor: 'pointer',
										}}>
										<span style={{ fontSize: 16 }}>Have a coupan code ?</span>

										<ArrowForwardIosIcon
											style={{ fontSize: 16, color: 'orangered' }}
										/>
									</Box>
								</Box>
								<Box
									style={{
										boxShadow: '0 0 10px rgba(0,0,0,.3)',
										backgroundColor: '#FFF',
										marginTop: 20,
										// padding: 10,
									}}>
									<Box
										style={{
											backgroundColor: '#E1E1E1',
											color: 'rgba(0,0,0,.64)',
											padding: 10,
										}}>
										<span>Fare Summary</span>
									</Box>
									<Box
										style={{
											padding: 10,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}>
										<span style={{ fontSize: 12 }}>Fare Type</span>
										<span style={{ fontSize: 12, marginLeft: 10 }}>
											Partially Refundable
										</span>
									</Box>
									<Box
										style={{
											padding: 10,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}>
										<span style={{ fontSize: 12 }}>Base Fare</span>
										<span style={{ fontSize: 12, marginLeft: 10 }}>₹25150</span>
									</Box>
								</Box>
							</>
						) : (
							''
						)}
						<Box
							style={{
								boxShadow: '0 0 10px rgba(0,0,0,.3)',
								backgroundColor: '#FFF',
								marginTop: 20,
								padding: 10,
							}}>
							<FlightSummaryForm />
						</Box>
					</Grid>
					{matches ? (
						''
					) : (
						<Grid item xs={12} lg={4}>
							<Box
								style={{
									boxShadow: '0 0 10px rgba(0,0,0,.3)',
									backgroundColor: '#FFF',
									marginTop: 20,
									// padding: 10,
								}}>
								<Box
									style={{
										backgroundColor: '#E1E1E1',
										color: 'rgba(0,0,0,.64)',
										padding: 10,
									}}>
									<span>Offers</span>
								</Box>
								<Box
									onClick={() => dispatch(setModal(true))}
									style={{
										padding: 12,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										cursor: 'pointer',
									}}>
									<span style={{ fontSize: 16 }}>Have a coupan code ?</span>

									<ArrowForwardIosIcon
										style={{ fontSize: 16, color: 'orangered' }}
									/>
								</Box>
							</Box>
							<Box
								style={{
									boxShadow: '0 0 10px rgba(0,0,0,.3)',
									backgroundColor: '#FFF',
									marginTop: 20,
									// padding: 10,
								}}>
								<Box
									style={{
										backgroundColor: '#E1E1E1',
										color: 'rgba(0,0,0,.64)',
										padding: 10,
									}}>
									<span>Fare Summary</span>
								</Box>
								<Box
									style={{
										padding: 10,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}>
									<span style={{ fontSize: 12 }}>Fare Type</span>
									<span style={{ fontSize: 12, marginLeft: 10 }}>
										Partially Refundable
									</span>
								</Box>
								<Box
									style={{
										padding: 10,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}>
									<span style={{ fontSize: 12 }}>Base Fare</span>
									<span style={{ fontSize: 12, marginLeft: 10 }}>₹25150</span>
								</Box>
							</Box>
						</Grid>
					)}
				</Grid>
			</Container>
			<CoupanModal />
			<Footer />
		</div>
	);
};

export default FlightDetailPage;
